import React from 'react'
import {getPlaceHolderImage} from '../../../utils/helpers'
import {BUILDING, FLOOR, ROOM, DEPARTMENT, EMPLOYEE, EQUIPMENT} from '../Prompt'
import styled from 'styled-components'
import {_L, useLocaleState} from '../../../context/LocaleContext'

const Container = styled.div`
  padding: 10px;
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: auto 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 4px;
  align-items: center;
  margin-bottom: 4px;
  box-sizing: border-box;
  cursor: pointer;
`

const Section = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: ${props => (props.isBold ? '600' : '500')};
`

const TopSection = styled(Section)`
  grid-row: 1;
  grid-column: 2;
`

const BottomSection = styled(Section)`
  grid-row: 2;
  grid-column: 2;
`

const StyledImage = styled.img`
  grid-row: 1 / 3;
  grid-column: 1;
  height: 56px;
  width: 56px;
  object-fit: contain;
`

const ListItem = styled.li`
  margin-top: 03px;
  margin-left: 0px;
  border: 3px solid #FFFFFF;
  	
  &:hover {
    background-color: #f3f9ff;
  }

  &:focus {
    background-color: #f3f9ff;
    border: 3px solid #FF9900;
  }
`

const renderBuildingRow = item => {
  const {blId, name, blName, cityName, cityStateId, url} = item
  return (
    <>
      <StyledImage src={url || getPlaceHolderImage('building')} />
      <TopSection isBold>
        {blName === null ? blId : name + ' (' + blId + ')'}
      </TopSection>
      <BottomSection>
        {cityName}
        {cityStateId ? ' ,' + cityStateId : ''}
      </BottomSection>
    </>
  )
}

const renderFloorRow = item => {
  const {flId, name, blName} = item
  return (
    <>
      <TopSection isBold>
        {name} - {flId}
      </TopSection>
      <BottomSection>{blName}</BottomSection>
    </>
  )
}

const renderRoomRow = item => {
  const {rmId, blName} = item
  return (
    <>
      <TopSection isBold>{rmId}</TopSection>
      <BottomSection>{blName}</BottomSection>
    </>
  )
}

const renderEquipmentRow = (item, localeState) => {
  const floorTxt = _L({key: 'Floor', localeState})
  const {
    eqId,
    eqStd,
    use1,
    // mfr,
    // modelno,
    blName,
    flId,
    rmId,
    rmName,
    rmRmType
  } = item
  return (
    <>
      <TopSection isBold>{use1 + ' (' + eqId + ')'}</TopSection>
      <BottomSection>
        {eqStd +
          ' ' +
          blName +
          ' - ' +
          floorTxt +
          flId +
          ' - ' +
          rmId +
          ' - ' +
          (rmName || rmRmType)}
      </BottomSection>
    </>
  )
}

const renderEmployeeRow = (item) => {
  const {emId, url} = item
  return (
    <>
      <StyledImage src={url || getPlaceHolderImage('employee')} />
      <TopSection isBold>{emId}</TopSection>
    </>
  )
}

const renderDepartmentRow = (item) => {
  const {dpName, dvId, dpDpId} = item
  return (
    <>
      <TopSection isBold>{dpName}</TopSection>
      <BottomSection>
        {dvId} - {dpDpId}
      </BottomSection>
    </>
  )
}

const renderRow = (item, type, localeState) => {
  let row = null

  switch (type) {
    case BUILDING:
      row = renderBuildingRow(item)
      break
    case FLOOR:
      row = renderFloorRow(item)
      break
    case ROOM:
      row = renderRoomRow(item)
      break
    case EQUIPMENT:
      row = renderEquipmentRow(item, localeState)
      break
    case EMPLOYEE:
      row = renderEmployeeRow(item)
      break
    case DEPARTMENT:
      row = renderDepartmentRow(item)
  }

  return row
}

const PromptRow = ({item, onClick, style, type}) => {
  const localeState = useLocaleState()
  const onItemClick = (evt) => {
	  
    if(evt.key == "Enter" || evt.key == " " || !evt.key){
    
	    let promptType = {promptType: type}
	    onClick({...item, ...promptType})
    }
  }

  return (
    <ListItem tabIndex="0" style={style} onClick={onItemClick} onKeyDown={onItemClick}>
      <Container>{renderRow(item, type, localeState)}</Container>
    </ListItem>
  )
}

export default PromptRow
